import { and, eq } from "drizzle-orm";
import { redirect } from "react-router";
import { z } from "zod";
import { requireSess } from "~/auth.server";
import { CharacterPage } from "~/pages/tracker/CharacterPage";
import { pg } from "~/pg.server";
import { $LOADER, $PAGE } from "~/util/Loaders";
import { logPageView } from "~/util/stats";

const PageQuery = z.object({
  date: z.optional(z.string()),
});

$PAGE({
  path: "tracker/:characterId/character",
  loader: $LOADER?.(async (args) => {
    // Log
    logPageView(args);
    //
    const sess = requireSess(args.req.sess);

    const query = PageQuery.parse(
      Object.fromEntries(args.url.searchParams.entries()),
    );

    const Params = z.object({ characterId: z.string() });
    const params = Params.parse(args.params);
    const characterResult = await pg.db
      .select()
      .from(pg.tkChars)
      .where(
        and(
          eq(pg.tkChars.id, parseInt(params.characterId)),
          eq(pg.tkChars.userId, sess.user.id),
        ),
      );

    const character = characterResult.at(0);
    if (!character) {
      return redirect("/tracker");
    }
    return { character, authUser: args.req.sess?.user };
  }),
  meta: (args) => {
    const title = "Tracker";
    const characterName = args.data.character.charName;
    return {
      title: `${characterName} - ${title} - L2Hub`,
      description: "Stats character L2Hub",
    };
  },
  render: ({ data }) => {
    return <CharacterPage data={data} />;
  },
});
